import React, { Component } from "react";
import ZPartner01GrabHeader from "./ZPartner01GrabHeader";
import ZPartner01GrabFooter from "./ZPartner01GrabFooter";
import { getClientId } from "./utils/analyticsclientIdUtils";

export class ZPartner01XtestRetriveParam extends Component {
    static displayName = ZPartner01XtestRetriveParam.name;

    constructor(props) {
        super(props);
        this.state = {
            grabUserId: "",
            merchantId: "",
            termsChecked: false,
        };

        this.__isUnmounted = false;

        this.handleTermsChange = this.handleTermsChange.bind(this);
        this.handleSubmitYes = this.handleSubmitYes.bind(this);
        this.handleSubmitNo = this.handleSubmitNo.bind(this);
    }

    componentWillUnmount() {
        this.__isUnmounted = true;
    }

    componentDidMount() {
        const links = [
            "https://fonts.googleapis.com/css?family=Lato:300&text=1234567890,.-",
            "/css/style.css",
            "/css/style-sr.css"
        ];

        links.forEach(href => {
            const link = document.createElement("link");
            link.rel = "stylesheet";
            link.href = href;
            document.head.appendChild(link);
        });

        // Google Analytics / GTM tracking (same idea as EnAuthSignin)
        const documentPath = "Partner01_Index";
        const clientId = getClientId();

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "pageview",
            page: documentPath,
            clientId: clientId
        });

        this.initFromGrabWebView();
    }

    initFromGrabWebView() {
        try {
            // Run only once per page load
            if (window.__grabInitOnce) return;
            window.__grabInitOnce = true;

            // Prefer query string (redirect use-case)
            const params = new URLSearchParams(window.location.search);
            const qGrabUserId = String(params.get("grabUserId") ?? "").trim();
            const qMerchantId = String(params.get("merchantId") ?? "").trim();

            if (qGrabUserId || qMerchantId) {
                return this.applyGrabData({
                    grabUserId: qGrabUserId,
                    merchantId: qMerchantId,
                });
            }

            // Fallback to injected grabWebView (in-app browser use-case)
            if (
                window.grabWebView &&
                typeof window.grabWebView.passInfoToWebView === "function"
            ) {
                const response = window.grabWebView.passInfoToWebView();
                if (!response) {
                    window.location.replace("/X01PartnerConnect/Error?S=2");
                    return;
                }

                const data = JSON.parse(response);
                return this.applyGrabData({
                    grabUserId: String(data.grabUserId ?? "").trim(),
                    merchantId: String(data.merchantId ?? "").trim(),
                });
            }

            window.location.replace("/X01PartnerConnect/Error?S=2");
        } catch (e) {
            if (e instanceof ReferenceError) {
                window.location.replace("/X01PartnerConnect/Error?S=3");
            } else {
                window.location.replace("/X01PartnerConnect/Error?S=4");
            }
        }
    }

    applyGrabData(data) {
        const grabUserId = String(data?.grabUserId ?? "").trim();
        const merchantId = String(data?.merchantId ?? "").trim();

        if (!grabUserId && !merchantId) {
            window.location.replace("/X01PartnerConnect/Error?S=1");
            return;
        }

        if (this.__isUnmounted) return;

        this.setState({
            grabUserId,
            merchantId,
        });
    }

    handleTermsChange(event) {
        this.setState({ termsChecked: event.target.checked });
    }

    handleSubmitYes(event) {
        event.preventDefault();
        if (!this.state.termsChecked) return;

        this.props.history.push({
            pathname: "/X01PartnerConnect/MemberSignIn",
            state: {
                grabUserId: this.state.grabUserId,
                merchantId: this.state.merchantId
            }
        });
    }

    handleSubmitNo(event) {
        event.preventDefault();
        if (!this.state.termsChecked) return;

        this.props.history.push({
            pathname: "/X01PartnerConnect/MemberNew",
            state: {
                grabUserId: this.state.grabUserId,
                merchantId: this.state.merchantId
            }
        });
    }

    render() {
        const { grabUserId, merchantId, termsChecked } = this.state;

        return (
            <>
                <ZPartner01GrabHeader />

                <main id="main">
                    <section className="top-sr-bg bg-gray1">
                        <div className="container">
                            <div className="row justify-content-between">
                                <div className="col col-md-6">
                                    <h1 className="text-headpage text-white mb-0 pt-3 pb-3 ">
                                        <span className="d-none">Starbucks® Rewards</span>
                                        <img src="media/rewards/starbucks-rewards-logo-2.png" alt="Starbucks® Rewards" className="img-fluid" style={{ maxWidth: '158px' }} />
                                    </h1>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="section-sign-in overflow-hidden pb-5">
                        <div className="container p-1 p-md-0">
                            <div className="row">
                                <div className="col-md-12 mb-5 pt-3 text-center">
                                    <h2 className="h3 mt-5 fw-bold text-dark-212121">ข้อกำหนดและเงื่อนไขเกี่ยวกับการผูกบัญชีสมาชิก Grab และ Starbucks® Rewards</h2>
                                </div>
                            </div>
                            <div className="row justify-content-center px-1 px-md-5">
                                <div className="col-md-6 mb-3 pt-3 ">
                                    <div className="py-5 p-4 box-sign-in text-break">
                                        <p>Test</p>
                                        <div className="form-check mb-4">
                                            <label className="form-check-label">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    checked={termsChecked}
                                                    onChange={this.handleTermsChange}
                                                />{" "}
                                                รับทราบข้อตกลงและเงื่อนไข / I have read and agreed to the Terms &amp; Conditions.
                                            </label>
                                        </div>
                                        <div className="row">
                                            <div className="col-12">
                                                <button
                                                    type="button"
                                                    className="btn btn-primary rounded-pill px-4 w-100 mb-3"
                                                    onClick={this.handleSubmitYes}
                                                    disabled={!termsChecked}
                                                >
                                                    เป็นสมาชิก / Yes
                                                </button>
                                            </div>
                                            <div className="col-12">
                                                <button
                                                    type="button"
                                                    className="btn btn-primary rounded-pill px-4 w-100"
                                                    onClick={this.handleSubmitNo}
                                                    disabled={!termsChecked}
                                                >
                                                    ไม่เป็นสมาชิก / No
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style={{ marginTop: 24 }}>
                            <small>
                                Debug: grabUserId = {grabUserId || "(empty)"}, merchantId ={" "}
                                {merchantId || "(empty)"}
                            </small>
                        </div>
                    </section>
                </main>

                <ZPartner01GrabFooter />
            </>

        );
    }
}
